import { createFileRoute } from "@tanstack/react-router";
import { seo, seoLinks } from "~/utils/seo";
import { SupportAndServices } from "~/components/pricing/SupportAndServices";
import { FinalCta } from "~/components/pricing/FinalCta";

export const Route = createFileRoute("/pricing/support")({
  loader: () => ({}),
  head: () => ({
    meta: seo({
      title: "Support & Services — Pricing | C1",
      description:
        "Support tiers and implementation packages for a planned rollout.",
      url: "/pricing/support",
    }),
    links: seoLinks({ url: "/pricing/support" }),
  }),
  component: SupportPage,
});

function SupportPage() {
  return (
    <>
      <SupportAndServices />
      <FinalCta />
    </>
  );
}
